module.exports = __webpack_public_path__ + "img/yj40-0a.asm.7c3944e9.jpg";